var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDraftsEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_create",
    "data-name": " create",
    transform: "translate(-576 -1482)",
    opacity: 0.853
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Path",
    width: 24,
    height: 24,
    transform: "translate(576 1482)",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M582.54,1503H579.5a.5.5,0,0,1-.5-.5v-3.04a.5.5,0,0,1,.15-.36l10.91-10.91,3.75,3.75-10.92,10.91A.47.47,0,0,1,582.54,1503Zm12.34-12.13h0l-3.75-3.75,1.83-1.83a1,1,0,0,1,1.41,0l2.34,2.34a1,1,0,0,1,0,1.409l-1.829,1.83Z",
    fill: "#eba83c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftsEditIcon);
export default __webpack_public_path__ + "static/media/drafts-edit-icon.18a554c70ac02f1d4e3fd858d0201872.svg";
export { ForwardRef as ReactComponent };